import jQuery from "../modules/jquery/jquery-3.6.1.min.js"
jQuery(document).ready(function($) {
	$('.wpcf7-validates-as-required').parent().prev().addClass('required');
});